<!----
    Author: hjlee
    Description:
        HTML 에디터 컨트롤
---->
<template>
  <div class="html-editor">
    <div v-if="readonly" class="readonly-mode">
      [{{ $t('common.text.readonly') }}]
    </div>
    <div v-if="disabled" class="disabled-mode">
      [{{ $t('common.text.disabled') }}]
    </div>
    <quill-editor
      v-if="mounted"
      v-model="inputVal"
      :class="{'vue-editor-control': true, 'disabled': disabled, 'readonly': readonly}"
      :placeholder="placeholder"
      :disabled="readonly || disabled"
      :options="editorOptionsInner"
      @change="onChange($event)"
    />
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: String,
      default: undefined
    },
    placeholder: {
      type: String,
      default: ''
    },
    readonly: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    editorOptions: {
      type: Object,
      default: undefined
    }
  },
  data: function() {
    return {
      inputVal: '',
      mounted: false,
      editorOptionsInner: undefined
    }
  },
  watch: {
    value: function(newVal) {
      this.inputVal = newVal
    }
  },
  mounted() {
    this.editorOptionsInner = this.editorOptions
    if (!this.editorOptionsInner) {
      this.editorOptionsInner = {}
    }
    if (!this.editorOptionsInner.placeholder) {
      if (this.placeholder) {
        this.editorOptionsInner.placeholder = this.placeholder
      } else {
        this.editorOptionsInner.placeholder = this.$t(
          'common.placeholder.insert_contents'
        )
      }
    }
    this.inputVal = this.value
    this.originalInput = this.inputVal
    this.mounted = true
  },
  beforeDestroy() {
    if (this.inputTimer) {
      clearTimeout(this.inputTimer)
      this.inputTimer = undefined
    }
  },
  methods: {
    onChange($event) {
      if (this.inputVal !== this.originalInput) {
        this.$emit('input', this.inputVal)
        this.$emit('change', this.inputVal)
        this.$emit('forceUpdate')
        this.$forceUpdate()
      }
    }
  }
}
</script>

<style scoped>
.vue-editor-control.disabled {
  background-color: #dddddd;
  opacity: 0.8;
}
.vue-editor-control.readonly .ql-toolbar,
.vue-editor-control.disabled .ql-toolbar {
  display: none;
}
.readonly-mode,
.disabled-mode {
  padding: 20px;
  color: #999999;
  font-size: 0.8rem;
}
</style>
